import { render, staticRenderFns } from "./lessonLayout.vue?vue&type=template&id=3cf3d3c5&"
import script from "./lessonLayout.vue?vue&type=script&lang=js&"
export * from "./lessonLayout.vue?vue&type=script&lang=js&"
import style0 from "./lessonLayout.vue?vue&type=style&index=0&id=3cf3d3c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResourceDrawer: require('/opt/buildhome/repo/components/ResourceDrawer.vue').default})
